import { render, staticRenderFns } from "./ProductType.vue?vue&type=template&id=58a6bd39&scoped=true&"
import script from "./ProductType.vue?vue&type=script&lang=js&"
export * from "./ProductType.vue?vue&type=script&lang=js&"
import style0 from "./ProductType.vue?vue&type=style&index=0&id=58a6bd39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a6bd39",
  null
  
)

export default component.exports